class DropdownController {
  _dropdownContainerSelector = ".dropdown-container";
  _dropdownContainerEl = document.querySelector(
    this._dropdownContainerSelector
  );
  _menuItemEls = document.querySelectorAll(
    ".header__menu-item:not([data-dropdown-id])"
  );
  _activeDropdown = null;
  _dropdowns = [];

  constructor() {
    this._handleOutterClick = this._handleOutterClick.bind(this);
    this._handleMenuItemHover = this._handleMenuItemHover.bind(this);

    if (DropdownController.instance == null) {
      DropdownController.instance = this;
    }
    return DropdownController.instance;
  }

  registerDropdown(dropdownId) {
    const element = this._dropdownContainerEl.querySelector(
      `#dropdown-${dropdownId}`
    );
    if (!element) {
      return console.error(
        `No dropdown menu element found for "#dropdown-${dropdownId}"`
      );
    }
    // create dropdown object
    const dropdown = { element, id: dropdownId };
    this._dropdowns[dropdownId] = dropdown;
    this._initDropdownActivators(dropdown);
  }

  _initDropdownActivators(dropdown) {
    const activatorSelector = this._getActivatorSelector(dropdown.id);
    const activatorEls = document.querySelectorAll(activatorSelector);
    if (!activatorEls.length) {
      return console.warn(
        `No dropdown menu activators found for ${activatorSelector}`
      );
    }

    // set event listener on dropdown activator elements
    activatorEls.forEach((el) => {
      // el.style.cursor = "pointer";
      el.addEventListener("mouseover", (e) =>
        this._activatorHandler(e, el, dropdown)
      );
    });
  }

  _getActivatorSelector(dropdownId) {
    return `[data-dropdown-id="${dropdownId}"]`;
  }

  _activateActivatorEl(el) {
    el.classList.add("active-dropdown");
  }

  _deactivateActivatorEl(el) {
    el.classList.remove("active-dropdown");
  }

  _openDropdown(dropdown) {
    if (dropdown.activatorEl) {
      this._activateActivatorEl(dropdown.activatorEl);
    }
    dropdown.element.classList.add("dropdown--open");
    this._setMenuItemHoverListener();
    document.addEventListener("click", this._handleOutterClick);
    this._activeDropdown = dropdown;
  }

  _closeDropdown({ element, activatorEl }) {
    if (activatorEl) {
      this._deactivateActivatorEl(activatorEl);
    }
    element.classList.remove("dropdown--open");
    element.classList.remove("dropdown--hide"); // remove instant hide class if present
    this._destroyMenuItemHoverListener();
    document.removeEventListener("click", this._handleOutterClick);
    this._activeDropdown = null;
  }

  _activatorHandler(e, activatorEl, dropdown) {
    e.stopPropagation();

    if (this._activeDropdown && this._activeDropdown.id !== dropdown.id) {
      return this._closeDropdown(this._activeDropdown);
    }

    if (this._activeDropdown) {
      this._closeDropdown(this._activeDropdown);
    }

    this._openDropdown({ ...dropdown, activatorEl });
  }

  _findActiveActivatorEl(selector) {
    return document.querySelector(this._getActivatorSelector(selector));
  }

  _handleOutterClick(e) {
    if (!e.target.closest(".dropdown--open")) {
      this._closeDropdown(this._activeDropdown);
    }
  }

  /**
   * Close dropdown if another menu item is hovered over
   */
  _handleMenuItemHover() {
    // this._instantHideDropdown();
    // setTimeout(() => {
    this._closeDropdown(this._activeDropdown);
    // });
  }

  _instantHideDropdown() {
    this._activeDropdown.element.classList.add("dropdown--hide");
  }

  _setMenuItemHoverListener() {
    this._menuItemEls.forEach((el) =>
      el.addEventListener("mouseenter", this._handleMenuItemHover)
    );
  }

  _destroyMenuItemHoverListener() {
    this._menuItemEls.forEach((el) =>
      el.removeEventListener("mouseenter", this._handleMenuItemHover)
    );
  }
}

const dropdownController = new DropdownController();

export default dropdownController;
